import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GoogleSheetSyncFacade, GoogleSheetUploadFacade } from '@mode/dataset/google/contract';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { UploadSheetService, UploadSheetDialogService } from '@mode/dataset/google/feature-dialog';
import { GoogleSheetSyncEffects } from './google-sheet-sync/google-sheet-sync.effects';
import { EffectsModule } from '@ngrx/effects';
import { GoogleSheetSyncFacadeService } from './google-sheet-sync/google-sheet-sync-facade.service';
import * as fromGoogleSheetSync from './google-sheet-sync/google-sheet-sync.reducer';
import { StoreModule } from '@ngrx/store';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([GoogleSheetSyncEffects]),
    StoreModule.forFeature(
      fromGoogleSheetSync.GOOGLE_SHEET_SYNC_FEATURE_KEY,
      fromGoogleSheetSync.googleSheetSyncReducer
    ),
  ],
  providers: [
    UploadSheetDialogService,
    { provide: GoogleSheetUploadFacade, useClass: UploadSheetService },
    { provide: GoogleSheetSyncFacade, useClass: GoogleSheetSyncFacadeService },
  ],
})
export class DatasetGoogleDomainModule {}
